"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppleProxySearchAppResponseSchema = exports.AppleProxySearchAppSchema = exports.AppleProxySearchAppQuerySchema = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../../../core");
const campaigns_1 = require("./campaigns");
const core_2 = require("./core");
exports.AppleProxySearchAppQuerySchema = (0, core_1.StrictObject)({
    query: typebox_1.Type.Optional(typebox_1.Type.String()),
    returnOwnedApps: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
    limit: typebox_1.Type.Optional(typebox_1.Type.Number()),
    offset: typebox_1.Type.Optional(typebox_1.Type.Number()),
});
exports.AppleProxySearchAppSchema = (0, core_1.StrictObject)({
    adamId: core_2.AppleProxyAdamRefSchema,
    appName: typebox_1.Type.String(),
    countryOrRegionCodes: typebox_1.Type.Array(campaigns_1.AppleProxyCountryOrRegionSchema),
    developerName: typebox_1.Type.String(),
});
exports.AppleProxySearchAppResponseSchema = typebox_1.Type.Object({
    data: (0, core_1.OptionalNullable)(typebox_1.Type.Array(exports.AppleProxySearchAppSchema), {
        title: "Data",
        description: "Response data that the API provides.",
    }),
    error: (0, core_1.OptionalNullable)(core_2.AppleProxyErrorResponseBodySchema, {
        title: "Error",
        description: "Error response data that the API provides.",
    }),
    pagination: (0, core_1.OptionalNullable)(core_2.AppleProxyPageDetailSchema, {
        title: "Pagination",
        description: "Page detail information that the API provides.",
    }),
}, {
    title: "App Search Response",
    description: "A container for the iOS App search response body.",
});
